var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.007 2.505c.706 7.12 6.368 12.782 13.488 13.488.829.082 1.505-.6 1.505-1.432V11.88c0-.649-.415-1.225-1.03-1.43l-2.607-.868a1.507 1.507 0 0 0-1.542.364l-.417.417a.739.739 0 0 1-.939.093c-1.352-.925-2.11-1.681-2.937-2.926a.735.735 0 0 1 .1-.925l.426-.426c.404-.404.545-1 .364-1.542L6.55 2.03A1.507 1.507 0 0 0 5.12 1H2.44c-.833 0-1.515.677-1.433 1.505Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgPhone;